import React, { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Notification = ({ message, type }) => {
  // Automatically show notification when the component receives new props
  useEffect(() => {
    if (message && type) {
      if (type === 'success') {
        toast.success(message, {
          position: "top-right",
          autoClose: 5000,
          pauseOnHover: true,
          theme: "dark"
        });
      } else if (type === 'error') {
        toast.error(message, {
            position: "top-right",          
            autoClose: 5000,
            pauseOnHover: true,
            theme: "dark"
        });
      }
    }
  }, [message, type]); // Re-run whenever message or type changes

  return (
    <ToastContainer />
  );
};

export default Notification;
